/**
 * Utilitário para escapar caracteres HTML, prevenindo XSS e renderização incorreta
 * quando o conteúdo do template é inserido no DOM.
 *
 * @param str A string a ser escapada.
 * @returns A string com os caracteres HTML escapados.
 */
export function escapeHtml(str: string): string {
  if (!str) return '';
  return str
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}
